import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "sonner";
import { Loader } from "@/shared/ui/Loader";
import { Button } from "@/components/ui/button";


import { useNavigate, useParams } from "@tanstack/react-router";
import { TicketIcon } from "lucide-react";
import { useCouponQuery, useUpdateCouponMutation } from "../api/queries";
import { CouponForm } from "../ui/CouponForm";

export function CouponEditPage() {
  const nav = useNavigate({
    from: "/app/loyalty/promotions/coupons/$couponId/edit",
  });
  const { couponId } = useParams({
    from: "/app/loyalty/promotions/coupons/$couponId/edit",
  });
  const { data: coupon, isLoading } = useCouponQuery(couponId);
  const updateCoupon = useUpdateCouponMutation();

  if (isLoading) {
    return (
      <>
        <Header>
          <Breadcrumb
            items={[
              {
                label: "ຄູປອງ",
                to: "/app/loyalty/promotions/coupons",
              },
              {
                label: "ແກ້ໄຂຄູປອງ",
              },
            ]}
          />
        </Header>
        <Main>
          <div className="flex justify-center py-12">
            <Loader />
          </div>
        </Main>
      </>
    );
  }

  if (!coupon) {
    return (
      <>
        <Header>
          <Breadcrumb
            items={[
              {
                label: "ຄູປອງ",
                to: "/app/loyalty/promotions/coupons",
              },
              {
                label: "ແກ້ໄຂຄູປອງ",
              },
            ]}
          />
        </Header>
        <Main>
          <div className="text-center py-12">
            <p className="text-muted-foreground mb-4">ບໍ່ພົບຄູປອງ</p>
            <Button onClick={() => nav({ to: "/app/loyalty/promotions/coupons" })}>
              ກັບໄປລາຍການ
            </Button>
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ຄູປອງ",
              to: "/app/loyalty/promotions/coupons",
            },
            {
              label: "ແກ້ໄຂຄູປອງ",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-4">
          <h2 className="flex items-center gap-2 font-bold text-2xl tracking-tight">
            <TicketIcon className="size-5" />
            ແກ້ໄຂຄູປອງ
          </h2>
        </div>

        <CouponForm
          defaultValues={{
            promotionId: coupon.promotionId,
            code: coupon.code,
            maxRedemptions: coupon.maxRedemptions ?? null,
            perCustomerLimit: coupon.perCustomerLimit ?? null,
            isActive: coupon.isActive,
          }}
          onSubmit={async (payload) => {
            try {
              await updateCoupon.mutateAsync({ id: couponId, payload });
              toast.success("ບັນທຶກຄູປອງແລ້ວ");
              nav({ to: "/app/loyalty/promotions/coupons" });
            } catch (error) {
              const message =
                error instanceof Error
                  ? error.message
                  : "ບັນທຶກຄູປອງລົ້ມເຫຼວ";
              toast.error(message);
            }
          }}
          submitting={updateCoupon.isPending}
          onCancel={() => nav({ to: "/app/loyalty/promotions/coupons" })}
          submitLabel="ບັນທຶກການປ່ຽນແປງ"
        />
      </Main>
    </>
  );
}
